<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Task Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <prep-task-card v-if="prep_task.id" :prep_task="prep_task" />
    <b-form @submit.prevent="onSubmit">
      <b-card no-body class="mt-4">
        <b-card-header>
          <span class="text-muted text-uppercase">Prep Task Info</span>
        </b-card-header>
        <b-card-body>
          <b-form-group label="Identifier" :label-cols="2">
            <b-form-input
              type="text"
              v-model.trim="form_data.name"
              placeholder="Task Name"
            />
          </b-form-group>
          <b-form-group label="Description" :label-cols="2">
            <b-form-textarea
              v-model.trim="form_data.description"
              placeholder="Description"
            />
          </b-form-group>
        </b-card-body>
      </b-card>
      <task-instrument-form
        :task_instruments="form_data.relations.instruments"
        @pickInstruments="pickInstruments"
      />
      <b-card no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">Select Analusis(es)</span>
        </b-card-header>
        <b-card-body>
          <b-tabs>
            <b-tab 
              v-for="(sample_type, index) in sample_type_collection.models"
              :key="index"
              :title="sample_type.name"
            >
              <task-analysis-form
                :sample_type="sample_type"
                :task_analyses="form_data.relations.analyses"
                @pickAnalyses="pickAnalyses"
              />
            </b-tab>
          </b-tabs>
        </b-card-body>
      </b-card>
      <b-button
        class="my-4 float-right py-3 px-5"
        variant="success"
        @click="submitForm"
      >
        <i class="fal fa-address-book" /> Save
      </b-button>
    </b-form>
  </div>
</template>

<script>
import PrepProcessModel from "@/models/lab/PrepProcessModel";
import PrepTaskCard from "./PrepTaskCard";
import PrepTaskModel from "@/models/lab/PrepTaskModel";
import TaskAnalysisForm from "@/components/shared/form/TaskAnalysisForm";
import TaskInstrumentForm from "@/components/shared/form/TaskInstrumentForm";
import { getCollection } from "@/shared/fetch-utils";

export default {
  name: "PrepTaskForm",
  components: {
    PrepTaskCard,
    TaskAnalysisForm,
    TaskInstrumentForm,
  },
  props: {
    prep_process: {
      type: Object,
      default: () => new PrepProcessModel(),
    },
    prep_task: {
      type: Object,
      default: () => new PrepTaskModel(),
    },
  },
  data() {
    return {
      loading: true,
      form_data: {
        name: null,
        description: null,
        relations: {
          analyses: [],
          instruments: [],
        },
      },
      sample_type_collection: null,
    };
  },
  methods: {
    pickInstruments(picked_instruments) {
      this.form_data.relations.instruments = picked_instruments;
    },
    pickAnalyses(picked_analyses) {
      this.form_data.relations.analyses = picked_analyses;
    },
    submitForm() {
      return this.$emit("submit", this.form_data);
    },
  },
  async created() {
    this.loading = true;

    this.sample_type_collection = await getCollection({
      collection_type: "sample_type",
      filters: [
        {
          logic: "filterEquals",
          field: "prep_processes.id",
          value: this.prep_process.id,
        },
      ],
      message: this.$bvToast,
    });

    if (this.prep_task.id) {
      const { analyses, name, description, instruments } = this.prep_task;

      this.form_data = {
        name,
        description,
        relations: {
          instruments: instruments.map(({ id }) => id),
          analyses: analyses.map(({ id }) => id),
        },
      };
    }

    this.loading = false;
  },
};
</script>